import { useQueries } from '@tanstack/react-query';
import { API_PATIENT_KEY_NOTE } from 'services/dataService/resources';
import { ModuleType } from 'infrastructure/enums';
import QueryParams from 'utils/queryParams';

import { selectKeyNotesHistory } from './api/selectKeyNoteHistoryFn';

interface Props {
  patientGuid: string;
  module: ModuleType;
  canChangeModule?: boolean;
  noteGuid: string;
}
export const selectKeyNoteKey = ({ patientGuid, module, noteGuid }: Props) => [
  'selectKeyNoteData',
  patientGuid,
  module,
  noteGuid,
];

export const useSelectKeyNote = ({
  patientGuid,
  module,
  canChangeModule,
  noteGuid,
}: Props) => {
  const apiUrl = API_PATIENT_KEY_NOTE(patientGuid);
  const urlRPM = QueryParams.stringifyUrl(`${apiUrl}/select`, {
    module: ModuleType.RPM,
    guid: noteGuid,
  });
  const urlCCM = QueryParams.stringifyUrl(`${apiUrl}/select`, {
    module: ModuleType.CCM,
    guid: noteGuid,
  });

  const [rpmQueryData, ccmQueryData] = useQueries({
    queries: [
      {
        queryKey: selectKeyNoteKey({
          patientGuid,
          module: ModuleType.RPM,
          noteGuid,
        }),
        queryFn: () =>
          selectKeyNotesHistory({
            url: urlRPM,
          }),
        enabled: canChangeModule || module === ModuleType.RPM,
      },
      {
        queryKey: selectKeyNoteKey({
          patientGuid,
          module: ModuleType.CCM,
          noteGuid,
        }),
        queryFn: () =>
          selectKeyNotesHistory({
            url: urlCCM,
          }),
        enabled: canChangeModule || module === ModuleType.CCM,
      },
    ],
  });
  return [rpmQueryData, ccmQueryData];
};
